import { getContract } from 'viem';

// Config
import { abiStorage, TGE_ADDRESS } from '../config';

const useContract = () => {
  const contract = getContract({
    address: TGE_ADDRESS,
    abi: abiStorage.TGE.abi,
  });

  return { contract };
};

export default useContract;
